import React, {ReactElement, SVGProps} from 'react';
import cn from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';

// Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.
interface OverlappingCommentsIconProps extends SVGProps<SVGSVGElement> {
  tooltip?: ReactElement | string;
}

export const OverlappingCommentsIcon: React.FC<OverlappingCommentsIconProps> = props => {
  return (
    <Tooltip title={props.tooltip ?? ''}>
      <svg
        {...props}
        className={cn(props.className, 'icon overlapping-comments')}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512">
        <path d="M416 63.1V256C416 291.3 387.3 319.9 352 319.9L224 320L115.1 381.6C112.9 383.3 110.4 384 108 384C101.8 384 96 379.1 96 372V320L64 320C28.75 320 0 291.3 0 256V63.1C0 28.75 28.75 0 64 0H352C387.3 0 416 28.75 416 63.1V63.1zM144 310.1L211.4 272H352C360.7 272 368 264.8 368 256V64C368 55.25 360.7 48 352 48H64C55.25 48 48 55.25 48 64V256C48 264.8 55.25 272 64 272H144V310.1zM256 384V352H304V384C304 392.7 311.2 400 320 400H428.6L496 438.1V400H576C584.7 400 592 392.7 592 384V192C592 183.3 584.7 176 576 176H448V128H576C611.3 128 640 156.7 640 191.1V384C640 419.3 611.3 448 576 448L544 448V500C544 507.1 538.2 512 532 512C529.6 512 527.1 511.3 524.9 509.6L416 448L320 447.9C284.8 447.9 256 419.3 256 384V384z" />
      </svg>
    </Tooltip>
  );
};
